import { ofType, Epic } from "redux-observable";
import { merge, of } from "rxjs";
import { catchError, map, mergeMap, takeUntil } from "rxjs/operators";
import { selectAuthTokens } from "../../../../features/auth/selectors/auth.selector";
import { IAction } from "../../../../interface/action.interface";
import { IErrorDto } from "../../../../interface/dto/error.dto";
import { IRootState } from "../../../../redux/root.reducer";
import { searchToTrackList } from "../../../../service/tracked-list-search.api";
import {
    ITrackListSearchGetAction,
    trackListSearchSuccessAction,
    trackListSearchErrorAction,
    ListToTrackSearchActionTypes,
} from "./list-to-track.actions";

const searchLimit = 10;

export const listToTrackEpic: Epic<IAction, IAction, IRootState> = (action$) =>
    merge(
        action$.pipe(
            ofType<
                ITrackListSearchGetAction,
                ListToTrackSearchActionTypes.LIST_TO_TRACK_SEARCH_GET
            >(ListToTrackSearchActionTypes.LIST_TO_TRACK_SEARCH_GET),
            mergeMap((action) =>
                (action.payload.filter.length
                    ? searchToTrackList(
                          action.payload.filter,
                          searchLimit,
                          selectAuthTokens(),
                      )
                    : of([])
                ).pipe(
                    takeUntil(
                        action$.pipe(
                            ofType<
                                ITrackListSearchGetAction,
                                ListToTrackSearchActionTypes.LIST_TO_TRACK_SEARCH_GET
                            >(
                                ListToTrackSearchActionTypes.LIST_TO_TRACK_SEARCH_GET,
                            ),
                        ),
                    ),
                    map((result) => trackListSearchSuccessAction(result)),
                    catchError((error: IErrorDto) =>
                        of(trackListSearchErrorAction(error.message)),
                    ),
                ),
            ),
        ),
    );
